<template>
  <div>
    <!-- ヘッダー -->
    <v-app-bar color="primary" dark flat class="header">
      <v-btn style="position: absolute" icon @click="routerBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title style="min-width: fit-content;">下書き一覧</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- クラスフィルタ -->
      <ClassFilterDialog
        v-model="selectedClassIds"
        :classes="nurseryClasses"
        @apply="onFilterApply"
      />
    </v-app-bar>

    <v-container class="padding-box">

      <!-- 下書きリスト -->
      <div>
        <v-list>
          <template v-if="!fetchLoading">
            <!-- 個別 -->
            <div class="font-weight-bold pa-1">個別対応</div>
            <div v-if="chatsDraft.length === 0" class="pl-1">保存メールがありません</div>

            <div v-for="(chat, index) in chatsDraft" :key="chat.chatId">
              <template v-if="index > 0">
                <v-list-subheader
                  v-if="chat.date !== chatsDraft[index - 1].date"
                  class="attendance-list-header"
                >
                  <p class="ml-3 text-black">{{ formatDate(chat.date) }}</p>
                </v-list-subheader>
              </template>
              <template v-if="index === 0">
                <v-list-subheader class="attendance-list-header">
                  <p class="ml-3 text-black">{{ formatDate(chat.date) }}</p>
                </v-list-subheader>
              </template>

              <v-list-item @click="toChat(chat)" :value="chat.chatId">
                <div class="d-flex align-center pl-3" style="width: 100%;">
                  <div class="mr-3" v-if="checkReadyMine(chat.createdBy)">
                    <v-checkbox
                      v-model="checkbox"
                      :value="chat.chatId"
                      hide-details
                      density="compact"
                      @click.stop
                    ></v-checkbox>
                  </div>
                  
                  <div class="d-block pt-2 pb-2" style="flex: 1;">
                    <div class="d-flex align-center">
                      <p>{{ chat.child.lastName }} {{ chat.child.firstName }}</p>
                      <v-chip
                        color="primary"
                        class="ml-2"
                        variant="outlined"
                        size="x-small"
                      >
                        {{ chat.createdBy?.lastName }} {{ chat.createdBy?.firstName }}
                      </v-chip>
                    </div>
                    <p 
                      class="text-grey mt-1" 
                      style="max-width: 10em; white-space: pre-wrap; word-break: break-all;"
                    >
                      {{ showLongText(chat.body) }}
                    </p>
                  </div>
                </div>

                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

            </div>

            <!-- 一斉送信 -->
            <div class="font-weight-bold pa-1">一斉メッセージ</div>
            <div v-if="bulkChatsDraft.length === 0" class="pl-1">保存メールがありません</div>

            <div v-for="(bulkChat, index) in bulkChatsDraft" :key="bulkChat.groupChatId">

              <template v-if="index > 0">
                <v-list-subheader
                  v-if="bulkChat.date !== bulkChatsDraft[index - 1].date"
                  class="attendance-list-header"
                >
                  <p class="ml-3 text-black">{{ formatDate(bulkChat.date) }}</p>
                </v-list-subheader>
              </template>

              <template v-if="index === 0">
                <v-list-subheader class="attendance-list-header">
                  <p class="ml-3 text-black">{{ formatDate(bulkChat.date) }}</p>
                </v-list-subheader>
              </template>

              <v-list-item @click="toChatBulk(bulkChat)">
                <template v-slot:prepend>
                  <div class="mr-3">
                    <v-checkbox
                      v-model="checkboxBulk"
                      v-if="checkReadyMine(bulkChat.createdBy)"
                      :value="bulkChat.groupChatId"
                      hide-details
                      @click.stop
                    ></v-checkbox>
                  </div>
                </template>

                <div>
                  <div class="d-block pt-1 pb-2">
                    <div class="d-flex flex-column">
                      <div v-for="clas in bulkChat.to.classes" :key="clas.classId">
                        <p class="pr-1">{{ clas.className }}</p>
                      </div>
                    </div>
                    <div v-for="child in bulkChat.to.children" :key="child.childId">
                      <p class="pr-1">{{ child.lastName }} {{ child.firstName }}</p>
                    </div>
                    <v-chip 
                      color="primary"  
                      variant="outlined" 
                      size="x-small"
                      class="mb-2"
                    >
                      {{ bulkChat.createdBy?.lastName }} {{ bulkChat.createdBy?.firstName }}
                    </v-chip>
                    <p 
                      class="text-grey mt-1" 
                      style="max-width: 10em; white-space: pre-wrap; word-break: break-all;"
                    >
                      {{ showLongText(bulkChat.body) }}
                    </p>
                  </div>
                </div>

                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
                <v-divider class="my-2"></v-divider>
              </v-list-item>
            </div>
          </template>
          <template v-else>
            <VueLoading :height="'50vh'" />
          </template>
        </v-list>
      </div>
    </v-container>

    <v-footer color="white" class="draft-footer">
      <v-row class="mt-2 mb-2 d-flex justify-center">
        <v-col cols="6" class="pr-2 pl-2">
          <v-btn
            class=""
            color="error"
            variant="outlined"
            width="100%"
            @click="deleteChatDraft"
            :loading="btnLoading"
            :disabled="!(checkbox.length > 0 || checkboxBulk.length > 0)"
          >
            <div>
              <div class="text-h6 font-weight-bold message-btn">削除</div>
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script lang="ts">
import LocalDataService from '@/service/LocalDataService';
import { chatModule } from '@/store/dataModules/chatModule';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { ChatResponse, GroupChatResponse, NurseryClassResponse } from 'chaild-api/lib';
import VueLoading from '@/components/pages/Loding.vue';
import ClassFilterDialog from '@/components/ClassFilterDialog.vue';
import Vue from 'vue';
import { defineComponent } from "vue";

const dayOfWeekStrJP = ['日', '月', '火', '水', '木', '金', '土'];

export default defineComponent({
  components: {
    VueLoading,
    ClassFilterDialog,
  },
  data: () => {
    return {
      fetchLoading: false,
      btnLoading: false,
      dialog: false,
      checkbox: [],
      checkboxBulk: [],
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      selectedClassIds: [] as number[],
    };
  },
  computed: {
    chatsDraft(): ChatResponse[] {
      const chatsDraft = chatModule.chatsDraft;
      if (chatsDraft) {
        chatsDraft.sort(function(a, b) {
          if (a.date > b.date) {
            return -1;
          } else {
            return 1;
          }
        });
        return chatsDraft;
      }
      return [];
    },
    bulkChatsDraft(): GroupChatResponse[] {
      const bulkChatsDraft = chatModule.bulkChatsDraft;
      if (bulkChatsDraft) {
        bulkChatsDraft.sort(function(a, b) {
          if (a.date > b.date) {
            return -1;
          } else {
            return 1;
          }
        });
        return bulkChatsDraft;
      }
      return [];
    },
    nurseryClasses(): NurseryClassResponse[] {
      return nurseryModule.allClasses ?? [];
    },
  },
  methods: {
    showLongText(body: string) {
      let replace = body.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
      const length = replace.length;
      if (length > 55) {
        replace = replace.slice(0, 55) + '...';
        return replace;
      }
      return body;
    },
    checkReadyMine(createdBy) {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        if (createdBy.userId === nurserySchool.userId) {
          return true;
        } else {
          return false;
        }
      }
    },
    async routerBack() {
      this.snackbar = false;
      const routes = window.history.length;
      await sessionStorage.setItem('targetTab', 'message');
      this.$router.push('/')
    },
    toChat(chat: ChatResponse) {
      this.$router.push(
        `/communication/chat/${chat.child.childId}?draftChatId=${chat.chatId}&text=${chat.body}&userId=${chat.createdBy?.userId}`
      );
    },
    toChatBulk(chat: GroupChatResponse) {
      this.$router.push(`/communication/new-message?draftBulkChatId=${chat.groupChatId}&userId=${chat.createdBy?.userId}`);
    },
    deleteChatDraft: async function() {
      try {
        this.btnLoading = true;
        if (this.checkbox.length > 0) {
          const chatIds = this.checkbox.join(',');
          await chatModule.deleteChatDraft(chatIds);
          this.init();
          this.snackbar = true;
          this.checkbox = [];
        }
        if (this.checkboxBulk.length > 0) {
          const groupChatId = this.checkboxBulk.join(',');
          await chatModule.deleteAllChatDraft(groupChatId);
          this.init();
          this.snackbar = true;
          this.checkboxBulk = [];
        }
        this.snackBarText = '削除しました';
      } catch {
      } finally {
        this.btnLoading = false;
      }
    },
    formatDate(date: string) {
      const temp = date.split('-');
      const weekTemp = new Date(parseInt(temp[0]), parseInt(temp[1])-1, parseInt(temp[2]));
      const week = dayOfWeekStrJP[weekTemp.getDay()];
      const formated = `${temp[0]}年${temp[1]}月${temp[2]}日(${week})`;
      return formated;
    },
    async init() {
      this.fetchLoading = true;
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        // classIdsをクエリパラメータとして渡す
        const classIdsParam = this.selectedClassIds.length > 0
          ? this.selectedClassIds.join(',')
          : undefined;
        await Promise.all([
          chatModule.fetchChatDraft({ nurseryId, classIds: classIdsParam }),
          chatModule.getAllChatDraft({ nurseryId, classIds: classIdsParam }),
          nurseryModule.getAllNurseryClasses(nurseryId),
        ]);
      }
      this.$nextTick(() => {
        this.fetchLoading = false;
      });
    },
    onFilterApply() {
      this.init();
    },
  },
  async mounted() {
    this.init();
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/ress.scss' as *;
@use '@/sass/variables.scss' as *;

.attendance-list-header {
  background-color: #f5f6f6;
  height: 32px !important;
  font-weight: bold !important;
}

.draft-footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  background: #fff;
}

.padding-box {
  padding-bottom: 80px;
  padding-top: 60px;
}
.header {
  position: fixed;
  z-index: 2 !important;
}
</style>
